import { FormControl, Input, FormHelperText } from "@mui/material";

const InputField = ({
  label,
  required,
  handlekeypress,
  inputProps,
  onChange,
  onBlur,
  value,
  id,
  style,
  htmlFor,
  error,
  helperText,
  disabled,
  autoComplete="off",
  type = "text",
  errorColor,
  lineColor,
  focusLineColor
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          textAlign: "start",
          marginTop: "10px",
          fontSize: "18px",
          fontWeight: "400",
          color: style?.color
        }}
      >
        <label htmlFor={htmlFor}>
          {label}
          {required && (
            <span
              className="mandatory"
              style={{ color: "red", marginLeft: "5px" }}
            >
              *
            </span>
          )}
        </label>
      </div>
      <div style={{ width: "100%" }}>
        <FormControl style={style} variant="standard" error={error}>
          <Input
            id={id}
            type={type} 
            value={value}
            onChange={(e) => onChange(e)}
            onBlur={onBlur}
            inputProps={inputProps}
            style={{ color: style?.color,width:style?.width }} 
            sx={{
              '& .MuiInput-input': {
                color: style?.color || 'inherit',
                WebkitTextFillColor: style?.color || 'inherit',
                caretColor: style?.color || 'inherit',
              },
              ...(lineColor
                ? {
                    '&:before': { borderBottomColor: lineColor },
                    '&:hover:not(.Mui-disabled):before': { borderBottomColor: lineColor },
                  }
                : {}),
              ...(focusLineColor
                ? {
                    '&:after': { borderBottomColor: focusLineColor },
                  }
                : {}),
            }}
            disabled={disabled}
            autoComplete={autoComplete}
          />
         {helperText && <FormHelperText style={ errorColor ? { color: errorColor } : undefined }>{helperText}</FormHelperText>}
        </FormControl>
      </div>
    </div>
  );
};

export default InputField;